module.exports = __webpack_public_path__ + "media/images/iconSocialShare__inFrontOfAccent-1524f823e66f5a0a7b5f5d758f824ab9.png";